import { isSph2026Campaign } from '../campaign/uob-sbf-2026';
import './SLayout.css';

const SFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <section className="footer align-items-center d-flex justify-content-center">
      <div className="text-white">
        &copy; {currentYear} Strides Premier Private Hire and Limousine Pte. Ltd. |{' '}
        {isSph2026Campaign() && (
          <>
            <a
              href="https://stridespremier.com.sg/limousine-booking-promo/"
              target="_blank"
              rel="noreferrer"
            >
              <u className="text-white">Terms and Conditions</u>
            </a>
            {' | '}
          </>
        )}
        <a
          href="https://stridespremier.com.sg/terms-of-use/"
          target="_blank"
          rel="noreferrer"
        >
          <u className="text-white">Terms of Use</u>
        </a>{' '}
        |{' '}
        <a
          href="https://stridespremier.com.sg/privacy-policy/"
          target="_blank"
          rel="noreferrer"
        >
          <u className="text-white">Privacy Policy</u>
        </a>
      </div>
    </section>
  );
};

export default SFooter;
